// A wrapper for "JSON.parse()"" to support "undefined" value
export default function parseJSON<T>(value: string | null): T | undefined {
  try {
    return value === 'undefined' ? undefined : JSON.parse(value ?? '');
  } catch {
    console.error('Error parsing JSON value:', { value });
    return undefined;
  }
}
